var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPasswordKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66837",
    "data-name": "Group 66837",
    transform: "translate(-740 -377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(0 -53)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    rx: 20,
    ry: 20,
    transform: "translate(740 430)",
    fill: "#ffdada"
  })), /*#__PURE__*/React.createElement("g", {
    id: "key_2_",
    "data-name": "key (2)",
    transform: "translate(750.805 388.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66834",
    "data-name": "Group 66834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66833",
    "data-name": "Group 66833",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93683",
    "data-name": "Path 93683",
    d: "M16.8,1.748A5.975,5.975,0,0,0,6.89,7.816L.159,14.547A.543.543,0,0,0,0,14.931v3.075a.543.543,0,0,0,.543.543H3.618A.544.544,0,0,0,4,18.39l.769-.769a.544.544,0,0,0,.156-.447l-.1-.825,1.144-.108a.544.544,0,0,0,.49-.49l.108-1.144.825.1A.544.544,0,0,0,8,14.162V13.15H9a.544.544,0,0,0,.382-.157l1.35-1.335a5.975,5.975,0,0,0,6.07-9.91Zm-.769,7.686a4.892,4.892,0,0,1-5.242,1.091.544.544,0,0,0-.58.12L8.775,12.063H7.461a.544.544,0,0,0-.543.543v.945l-.771-.09a.544.544,0,0,0-.6.489L5.425,15.2l-1.249.118a.544.544,0,0,0-.489.6l.13,1.116-.424.424H1.087V15.156L7.9,8.342a.544.544,0,0,0,.122-.582,4.89,4.89,0,1,1,8.009,1.675Z",
    transform: "translate(0 0)",
    fill: "#ff4747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66836",
    "data-name": "Group 66836",
    transform: "translate(12.481 2.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66835",
    "data-name": "Group 66835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93684",
    "data-name": "Path 93684",
    d: "M347.282,78.005a1.631,1.631,0,1,0,0,2.306A1.632,1.632,0,0,0,347.282,78.005Zm-.769,1.537a.543.543,0,1,1,0-.769A.544.544,0,0,1,346.513,79.543Z",
    transform: "translate(-344.499 -77.529)",
    fill: "#ff4747"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordKey);
export default __webpack_public_path__ + "static/media/IconPasswordKey.661b9499.svg";
export { ForwardRef as ReactComponent };